import { MenuItem } from '@mui/material';

import { type Option } from '@/src/utils';

export function renderOptions(options: Array<Option>) {
    return options.map((option) => {
        return (
            <MenuItem key={option.id} value={option.id} title={option.name}>
                {option.name}
            </MenuItem>
        );
    });
}
